module.exports = __webpack_public_path__ + "img/karakters-30.1498d052.jpg";